"use strict";

exports.__esModule = true;
exports.EndDragFunction = exports.HistoryForwardFunction = exports.HistoryBackFunction = exports.DraggingOverMenuState = exports.CursorHistoryState = exports.HistoryState = exports.LanguagesState = exports.LanguageState = exports.ObjectFocusedState = exports.PresetsColumnsState = exports.getIdColumnHoverState = exports.ToolsState = exports.DocumentState = exports.DndActionState = exports.IdLineHoverState = exports.ColorsState = void 0;

var _recoil = require("recoil");

var _Blocks = require("../constants/Blocks");

var ColorsState = (0, _recoil.atom)({
  key: "colors",
  "default": []
});
exports.ColorsState = ColorsState;
var IdLineHoverState = (0, _recoil.atom)({
  key: "id-line-hover",
  "default": null
});
exports.IdLineHoverState = IdLineHoverState;
var DndActionState = (0, _recoil.atom)({
  key: "dnd-action",
  "default": null
});
exports.DndActionState = DndActionState;
var DocumentState = (0, _recoil.atom)({
  key: "document",
  "default": _Blocks.DOCUMENT
});
exports.DocumentState = DocumentState;
var ToolsState = (0, _recoil.atom)({
  key: "tools",
  "default": []
});
exports.ToolsState = ToolsState;
var getIdColumnHoverState = (0, _recoil.atomFamily)({
  key: "id-column-hover",
  "default": -2
});
exports.getIdColumnHoverState = getIdColumnHoverState;
var PresetsColumnsState = (0, _recoil.atom)({
  key: "presets-columns",
  "default": {
    1: {
      name: "1 colomn",
      presets: ["100%"]
    }
  }
});
exports.PresetsColumnsState = PresetsColumnsState;
var ObjectFocusedState = (0, _recoil.atom)({
  key: "object-focused",
  "default": null
});
exports.ObjectFocusedState = ObjectFocusedState;
var LanguageState = (0, _recoil.atom)({
  key: "language",
  "default": {
    name: "Français",
    key: "fr"
  }
});
exports.LanguageState = LanguageState;
var LanguagesState = (0, _recoil.atom)({
  key: "languages",
  "default": [{
    name: "Français",
    key: "fr"
  }]
});
exports.LanguagesState = LanguagesState;
var HistoryState = (0, _recoil.atom)({
  key: "history",
  "default": []
});
exports.HistoryState = HistoryState;
var CursorHistoryState = (0, _recoil.atom)({
  key: "cursor-history",
  "default": 0
});
exports.CursorHistoryState = CursorHistoryState;
var DraggingOverMenuState = (0, _recoil.atom)({
  key: "dragging-over-menu",
  "default": false
});
exports.DraggingOverMenuState = DraggingOverMenuState;
var HistoryBackFunction = (0, _recoil.selector)({
  key: "histor-back-fn",
  get: function get(_ref) {
    var _get = _ref.get,
        getCallback = _ref.getCallback;
  },
  set: function set(_ref2, idLine) {
    var _set = _ref2.set,
        get = _ref2.get;

    var _cursor = get(CursorHistoryState) - 1;

    _set(CursorHistoryState, _cursor);

    _set(ObjectFocusedState, null);

    _set(DocumentState, get(HistoryState)[_cursor]);
  }
});
exports.HistoryBackFunction = HistoryBackFunction;
var HistoryForwardFunction = (0, _recoil.selector)({
  key: "histor-forward-fn",
  get: function get(_ref3) {
    var _get2 = _ref3.get,
        getCallback = _ref3.getCallback;
  },
  set: function set(_ref4, idLine) {
    var _set2 = _ref4.set,
        get = _ref4.get;

    var _cursor = get(CursorHistoryState) + 1;

    _set2(CursorHistoryState, _cursor);

    _set2(ObjectFocusedState, null);

    _set2(DocumentState, get(HistoryState)[_cursor]);
  }
});
exports.HistoryForwardFunction = HistoryForwardFunction;
var EndDragFunction = (0, _recoil.selector)({
  key: "end-drag-fn",
  get: function get(_ref5) {
    var _get3 = _ref5.get,
        getCallback = _ref5.getCallback;
  },
  set: function set(_ref6) {
    var _set3 = _ref6.set,
        get = _ref6.get;

    _set3(DraggingOverMenuState, false);

    _set3(IdLineHoverState, null);

    _set3(DndActionState, null);
  }
});
exports.EndDragFunction = EndDragFunction;